import React, { Component } from 'react';
import { Table, message, Popconfirm, Select, Button, Form, Row, Col, Input, Space } from 'antd';
import { formItemLayout2 as formItemLayout } from '../../util/formItemLayoutConfig';
import send from '../../util/request';
import './style.less';

const { Option } = Select;
const { localStorage } = window;
// 0-未提报 1-已提报 2-已取消
const statusIndexToText = {
  "-1": "全部",
  "0": "未提报",
  "1": "已提报",
  "2": "取消提报"
};

class planReportDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      provinceList: [],
      cityList: [],
      provinceId: '',
      cityId: null
    };
  }
  columns = [
    {
      title: '统采公司名称',
      dataIndex: 'supplier_name',
      key: 'supplier_name',
      align: 'center',
    },
    {
      title: '统采公司编码',
      dataIndex: 'tripartite_code',
      key: 'tripartite_code',
      align: 'center',
    },
    {
      title: '采购公司名称',
      dataIndex: 'buyer_name',
      key: 'buyer_name',
      align: 'center',
    },
    {
      title: '采购公司编码',
      dataIndex: 'buyer_code',
      key: 'buyer_code',
      align: 'center',
    },
    {
      title: '计划采购开始日期',
      dataIndex: 'plan_start_time',
      key: 'plan_start_time',
      align: 'center',
    },
    {
      title: '计划采购结束日期',
      dataIndex: 'plan_end_time',
      key: 'plan_end_time',
      align: 'center',
    },
    {
      title: '计划收集开始日期',
      dataIndex: 'task_start_time',
      key: 'task_start_time',
      align: 'center',
    },
    {
      title: '计划收集结束日期',
      dataIndex: 'task_end_time',
      key: 'task_end_time',
      align: 'center',
    },
    {
      title: '计划名称',
      dataIndex: 'task_name',
      key: 'task_name',
      align: 'center',
    },
    {
      title: '计划名称编码',
      dataIndex: 'order_no',
      key: 'order_no',
      align: 'center',
    },
    {
      title: '商品名称',
      dataIndex: 'sale_name',
      key: 'sale_name',
      align: 'center',
    },
    {
      title: '商品编码',
      dataIndex: 'sku_no',
      key: 'sku_no',
      align: 'center',
    },
    {
      title: '商品等级',
      dataIndex: 'level',
      key: 'level',
      align: 'center',
    },
    {
      title: '商品产地',
      dataIndex: 'place',
      key: 'place',
      align: 'center',
    },
    {
      title: '商品单位',
      dataIndex: 'unit',
      key: 'unit',
      align: 'center',
    },
    {
      title: '商品规格',
      dataIndex: 'spec',
      key: 'spec',
      align: 'center',
    },
    {
      title: '商品价格（元）',
      dataIndex: 'sale_price',
      key: 'sale_price',
      align: 'center',
    },
    {
      title: '单位重量(KG)',
      dataIndex: 'weight',
      key: 'weight',
      align: 'center',
    },
    {
      title: '提报需求量',
      dataIndex: 'submit_number',
      key: 'submit_number',
      align: 'center',
      render: (text, record) => {
        let value = Number(text).toFixed(0);
        return +(record.submit_status) !== 1 ? <Input value={value} onChange={(event) => this.valueChanged(event, record, 'submit_number')}></Input> : <span>{value}</span>;
      }
    },
    {
      title: '提报重量(KG)',
      dataIndex: 'submit_weight',
      key: 'submit_weight',
      align: 'center',
    },
    {
      title: '所属SVC',
      dataIndex: 'svc_name',
      key: 'svc_name',
      align: 'center',
    },
    {
      title: '需求区域',
      dataIndex: 'area',
      key: 'area',
      align: 'center',
      render: (text, record) => {
        return <span>{record.province_name + '-' + record.city_name}</span>;
      }
    },
    {
      title: '提报状态',
      dataIndex: 'submit_status',
      key: 'submit_status',
      align: 'center',
      render: (text, record) => (
        <span>{statusIndexToText[record.submit_status]}</span>
      )
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      align: 'center',
      width: 150,
      render: (text, record) => (
        <Space size="middle">
          {+(record.submit_status) !== 1 && (
            <Popconfirm
              title="是否要提报?"
              onConfirm={() => this.handleSubmit(record, 1)}
              okText="确定"
              cancelText="取消">
              <a>提报</a>
            </Popconfirm>)
          }
          {+(record.submit_status) === 1 && (
            <Popconfirm
              title="是否要取消提报?"
              onConfirm={() => this.handleSubmit(record, 2)}
              okText="确定"
              cancelText="取消">
              <a>取消提报</a>
            </Popconfirm>)
          }
          {
            +(record.submit_status) !== 1 && (
              <Popconfirm
                title="是否要删除?"
                onConfirm={() => this.handleDelete(record)}
                okText="确定"
                cancelText="取消">
                <a>删除</a>
              </Popconfirm>
            )
          }
        </Space>
      ),
    },
  ]

  formRef = React.createRef();

  componentDidMount() {
    const account = localStorage.getItem('account');
    const companyId = localStorage.getItem('companyId');
    const companyName = localStorage.getItem('companyName');
    const taskDataStr = localStorage.getItem('taskData');
    const taskData = JSON.parse(taskDataStr);
    const { taskNo } = taskData;
    this.taskNo = taskNo;
    this.setState({
      account,
      companyId,
      companyName
    });
    this.requestAreaData();
    this.requestList();
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  requestAreaData(pid = 0) {
    send({
      url: '/ipp/order-plan-task/area',
      method: 'GET',
      params: {
        pid
      }
    }).then((res) => {
      if (res.data && res.data.code === 0) {
        const { data = [] } = res.data;
        if (pid === 0) {
          this.setState({
            provinceList: data
          });
        } else {
          this.setState({
            cityList: data
          });
        }
      }
    });
  }
  handleQuery = (values) => {
    const { productName, productCode, productLevel, productPlace, status = -1 } = values;
    this.setState({
      productName,
      productCode,
      productLevel,
      productPlace,
      status,
      currentPage: 1,
    });
    this.requestList();
  }
  handleReset = () => {
    this.formRef.current.resetFields();
    this.setState({
      currentPage: 1,
      productName: '',
      productCode: '',
      productLevel: '',
      productPlace: '',
      status: -1,
      provinceId: '',
      cityId: null
    }, () => {
      this.requestList();
    });
  }
  requestList() {
    const { currentPage, pageSize, productName, productCode, productLevel, productPlace, status = -1, provinceId, cityId } = this.state;
    let params = {
      page: currentPage,
      limit: pageSize,
      sale_name: productName,
      sku_no: productCode,
      level: productLevel,
      place: productPlace,
      order_no: this.taskNo,
      province_id: provinceId,
      city_id: cityId || '',
      submit_status: status //  0-未提报 1-已提报 2-已取消
    };
    if (+(status) === -1) {
      delete params.submit_status;
    }
    send({
      url: '/ipp/order-plan-task/submit-select',
      method: 'GET',
      params,
    }).then((res) => {
      this.setState({
        loading: false
      });
      if (res.data && res.data.code === 0) {
        let { data = [], total } = res.data.data;
        this.setState({
          list: data,
          total
        });
      }
    });
  }
  valueChanged = (event, record, key) => {
    let value = event.target.value;
    value = Number(value.replace(/\D/g, ''));
    record[key] = value;
    let { list } = this.state;
    let index = list.findIndex(obj => String(obj.id) === String(record.id));
    if (index !== -1) {
      list[index] = record;
      this.setState({
        list
      });
    }
  }
  handleSubmit = (record, status) => {
    const { id, submit_number } = record;

    // 提报前要保证需求量有值
    if (status === 1 && submit_number <= 0) {
      message.info('请先填写需求数量');
      return;
    }
    let data = {
      submit_id: id,
      submit_status: status,
      submit_number,
    };
    send({
      url: '/ipp/order-plan-task/submit-modify',
      method: 'POST',
      data
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success('操作成功');
        this.requestList();
      } else {
        message.error(res.data.msg, 2);
      }
    });
  }
  handleDelete = (record) => {
    const { id } = record;
    let data = {
      submit_id: id,
    };;
    send({
      url: '/ipp/order-plan-task/submit-del',
      method: 'POST',
      data
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success('删除成功');
        this.requestList();
      } else {
        message.error(res.data.msg, 2);
      }
    });
  }
  selectProducts = () => {
    const taskDataStr = localStorage.getItem('taskData');
    const taskData = JSON.parse(taskDataStr);
    const { taskNo, supplierName, supplierCode } = taskData;
    this.props.history.push(`/basic/user/planReport/select/${taskNo}/encodeURI(${supplierName})/${supplierCode}`);
  }
  provinceChanged = (value) => {
    this.setState({
      provinceId: value,
      cityId: '',
      cityList: []
    });
    this.requestAreaData(value);
  }

  cityChanged = (value) => {
    this.setState({
      cityId: value
    });
  }
  render() {
    const { account, companyId, companyName, list, currentPage, pageSize, total, provinceList, cityList, cityId } = this.state;

    return (
      <div className="plan-report-detail">
        <div>
          <span className="title">计划提报：</span>
          <span className="company-name">{companyName}公司（公司代码：{companyId}）计划提报账号：{account}</span>
        </div>
        <div style={{ marginTop: '20px' }}>
          <Form
            ref={this.formRef}
            {...formItemLayout}
            onFinish={this.handleQuery}>
            <Row>
              <Col span={8}>
                <Form.Item label='商品名称' name="productName">
                  <Input maxLength={100} placeholder='请输入商品名称' />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='商品编码' name="productCode">
                  <Input maxLength={100} placeholder='请输入商品编码' />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='商品等级' name="productLevel">
                  <Input maxLength={100} placeholder='请输入商品等级' />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='商品产地' name="productPlace">
                  <Input maxLength={100} placeholder='请输入商品产地' />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='所属区域' name="area">
                  <div style={{ display: 'flex' }}>
                    <Select placeholder='省' onChange={this.provinceChanged}>
                      {
                        provinceList.map(obj => <Option key={obj.id} value={obj.id}>{obj.name}</Option>)
                      }
                    </Select>
                    <Select placeholder='市' onChange={this.cityChanged} value={cityId}>
                      {
                        cityList.map(obj => <Option key={obj.id} value={obj.id}>{obj.name}</Option>)
                      }
                    </Select>
                  </div>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='提报状态' name="status">
                  <Select placeholder='请选择提报状态'>
                    {
                      Object.keys(statusIndexToText).sort().map(obj => <Option key={obj} value={obj}>{statusIndexToText[obj]}</Option>)
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8} offset={16} style={{ textAlign: 'right' }}>
                <Button type='primary' htmlType='submit'>查询</Button>
                <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>重置</Button>
              </Col>
            </Row>
          </Form>
        </div>
        <div style={{ margin: '20px 20px' }}>
          <Button type='primary' onClick={this.selectProducts}>添加需求</Button>
        </div>
        <div>
          <Table
            rowKey={record => record.id}
            columns={this.columns}
            dataSource={list}
            scroll={{ x: 3000 }}
            pagination={{
              pageSize: pageSize,
              total: total,
              current: currentPage,
              onChange: (currentPage, pageSize) => {
                this.setState(
                  {
                    currentPage,
                    pageSize,
                  },
                  () => {
                    this.requestList();
                  }
                );
              },
            }}
          />
        </div>
      </div>
    );
  }
}
export default planReportDetail;